export default __webpack_public_path__ + "static/media/koho_previous arrow white.8cb5b887.svg";